import React, {Component, Fragment} from "react";
import {Row} from "react-materialize";
import IndustryDimensionValues from "../../components/applicationComponents/industryDimensionValues";

class IndustryDimensionValue extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>
                <Row>
                    <Fragment>
                        <Row
                            className={this.state.isLoaded ? "card-container" : "card-container loader-wait"}
                        >
                            <IndustryDimensionValues history={this.props.history}/>
                        </Row>
                    </Fragment>
                </Row>
            </div>
        );
    }
}

export default IndustryDimensionValue;
